module.exports = __webpack_public_path__ + "static/zem101lp-cc05bb048a6452a515a788b1528ba299.png";